import { DeliveryMethodEnum, DeliveryTermsEnum, ItemResponsibleEnum, PackaginTrimsEnum, PaymentMethodEnum, PaymentTermsEnum, SalesPersonEnum, StatusEnum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('buyer_master')
export class buyerEntity {

    @PrimaryGeneratedColumn("increment", {
        name: "id",
    })
    id: number;

    @Column('varchar', {
        name: "buyer_name",
        length: 255
    })
    buyerName: string;

    @Column('varchar', {
        name: "buyer_code",
        length: 255
    })
    OrdersbuyerCode: string;


    @Column("enum", {
        enum: SalesPersonEnum,
        name: 'sales_person',
    })
    salesPerson: SalesPersonEnum;
    

    @Column("enum", {
        enum: ItemResponsibleEnum,
        name: 'item_responsible',
    })
    itemResponsible: ItemResponsibleEnum;

    
    @Column("enum", {
        enum: DeliveryTermsEnum,
        name: 'delivery_terms',
    })
    deliveryTerms: DeliveryTermsEnum;

    @Column('varchar', {
        name: "discount_one",
        length: 255
    })
    discountOne: string;

    @Column('varchar', {
        name: "discount_two",
        length: 255
    })
    discountTwo: string;

    @Column("enum", {
        enum: PackaginTrimsEnum,
        name: 'packaging_trims',
    })
    packagingTrims: PackaginTrimsEnum;

    
    @Column("enum", {
        enum: DeliveryMethodEnum,
        name: 'delivery_method',
    })
    deliveryMethod: DeliveryMethodEnum;

      
    @Column("enum", {
        enum: PaymentMethodEnum,
        name: 'payment_method',
    })
    paymentMethod: PaymentMethodEnum;


    @Column("enum", {
        enum: PaymentTermsEnum,
        name: 'payment_terms',
    }) 
    paymentTerms: PaymentTermsEnum;
    

    @Column('varchar', {
        name: "facility",
        length: 255
    })
    facility: string;

    @Column('varchar', {
        name: "ware_house",
        length: 255
    })
    wareHouse: string

    @Column('varchar', {
        name: "pch",
        length: 255
    })
    pch: string;

    @Column('varchar', {
        name: "buyer_po_date",
        length: 255
    })
    buyerPoDate: string;

    @Column('varchar', {
        name: "buyer_po",
        length: 255
    })
    buyerPo: string;

    @Column('varchar', {
        name: "shipment_type",
        length: 255
    })
    shipmentType: string;

    @Column('varchar', {
        name: "agent",
        length: 255
    })
    agent: string;

    @Column('varchar', {
        name: "sp_qty",
        length: 255
    })
    spQty: string;




    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;
    

    // @Column("enum", {
    //     enum: StatusEnum,
    //     name: 'status',
    //     default: StatusEnum.OPEN
    // })
    // status: StatusEnum;

}
